import { render } from "./userregis.vue?vue&type=template&id=15b6cece"
import script from "./userregis.vue?vue&type=script&lang=js"
export * from "./userregis.vue?vue&type=script&lang=js"

import "./userregis.vue?vue&type=style&index=0&id=15b6cece&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__